module.exports = __webpack_public_path__ + "img/16.e910f0d6.png";